import FlashingCircleGraph from "@/components/subject/FlashDiamond/FlashingCircleGraph";
import NineFlashingBoard from "@/components/subject/FlashDiamond/NineFlashingBoard";
import BoardFlashingAnimation from "@/components/subject/FlashDiamond/BoardFlashingAnimation";
import AnswerButtonGroup from "@/components/train/AnswerButtonGroup";
export default {
  name: "FlashDiamondRender",
  components: {
    AnswerButtonGroup,
    BoardFlashingAnimation,
    NineFlashingBoard,
    FlashingCircleGraph
  },
  props: {
    difficulty: {
      type: Object,
      default: () => {
        return {
          flashInterval: 1
        };
      }
    },
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };
  },
  methods: {
    onChoosed(l) {
      this.$emit('answer', l && l.length > 0 ? l[0] : null);
    },
    init() {
      this.$refs.answerBtns.init();
    }
  },
  mounted() {
    this.init();
  }
};